import { ReactElement, useCallback, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { INavLinkEndUser } from '.';
import { useActiveGliderClick } from '@hooks/useActiveGlider';
import { useEndUserStore } from '@store/enduser';
import { useFormTabNavigation } from '@hooks/useFormTabNavigation';
import { useGetRxDb } from '@hooks/getRxdbData';
import { ProfileData } from '@services/hooks/profile';
import { useIsImpersonationLoginUser } from '../../../../authGuard/hooks/useIsImpersonationLoginUser';

export const NavLinkEndUser = (props: INavLinkEndUser): ReactElement => {
	const { value, navData, listRef } = props;
	const { handleTabClick } = useActiveGliderClick();
	const { state, pathname } = useLocation();
	const { result: profile } = useGetRxDb<ProfileData>('profile');
	const userRole = profile?.[0]?.usertype_c;
	const isImpersonationLoginUser = useIsImpersonationLoginUser();

	useFormTabNavigation({ listRef: listRef, currentActiveTab: pathname });
	const { activeNavTabs, formId } = useEndUserStore();
	const isRBDM = userRole === 'RBDM';

	const path =
		formId && pathname.includes('edit-member-details')
			? `${navData.editMainRoutes}${navData.childRoute}`
			: `${navData.mainRoutes}${navData.childRoute}`;

	const isActive = pathname === path;
	// For RBDM users, or impersonation login users, all tabs should be enabled
	const isTabEnabled = isRBDM || isImpersonationLoginUser || activeNavTabs?.includes(value);

	const handleClick = useCallback(() => {
		if (isActive) {
			handleTabClick(value);
		}
	}, [handleTabClick, isActive, value]);

	useEffect(() => {
		if (isActive) {
			handleTabClick(value);
		}
	}, [handleTabClick, isActive, value]);

	return (
		<li className={`${isActive ? 'active' : ''} ${isTabEnabled ? 'tab-enable' : 'tab-disable'} `}>
			<NavLink to={path} className="tab" state={state} onClick={handleClick} aria-label={navData.title} end>
				<span className="icon-user"></span>
				{navData.title}
			</NavLink>
		</li>
	);
};
